import React, { useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import EmailCollectorModal from './EmailCollectorModal';

const Monitor = (props) => {

  const {
    parents,
    parentsPayment,
    extraClassName,
    style
  } = props

  const getColor = (index) => {
    return (parentsPayment[index]>0 ? 'blue-text' : 'gray-text')
  }

  const [isOpen, setIsOpen] = useState(false);


  const renderParentsPayments = () => {
    return (
      <Row style={{marginTop: -8}} className="parents-payments">
        <Col className='monitor-col' xs={{size:6}}>
          <h4>Parents</h4>
          <h5>{parents[0].name}</h5>
          <h5>{parents[1].name}</h5>
        </Col>
        <Col className='monitor-col' xs={{size:6}}>
          <h4>Per Month</h4>
          <h5 className={getColor(0)}>${parentsPayment[0].toFixed(2)}</h5>
          <h5 className={getColor(1)}>${parentsPayment[1].toFixed(2)}</h5>
        </Col>
      </Row>
    )
  }

  return (
    <div className={`monitor-container ${extraClassName}`} style={style}>
      
      <Row className='p-0 m-0 monitor-row'>
        <Col
          lg={{size:12, order:1}}
          xs={{size:12, order:2}}
          className='monitor-mobile-container p-0'
        >

          <Col className='monitor-title p-0' xs={{size:12}} style={{width:325}}>
            <h2>Child Support Payments</h2>
          </Col>
          {renderParentsPayments()}
        </Col>

        <Col
          lg={{size:12, order:2}}
          xs={{size:12, order:1}}
          className='d-flex justify-content-center'
          >
          <Button className='btn-blue cta full-calculator-btn' onClick={()=>setIsOpen(true)}>
            Full Calculator
          </Button>
        </Col>

      </Row>
      

      <EmailCollectorModal isModalOpen={isOpen} onClose={()=>setIsOpen(false)}/>
    </div>
  )
}

export default Monitor;

